import React, { useEffect, useState, useRef, useContext } from 'react';
import './profile.css';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import MapIcon from '../../assets/icons/map.svg';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import MapComponent from '../MapComponent';
import { GetCustomerInfo, UpdateCustomer } from '../../utils/api';
import moment from 'jalali-moment';
import Loadr from '../loader/loader';
import CustomerContext from '../../contexts/CustomerContext';  // Import CustomerContext

import { Dropdown } from 'primereact/dropdown';

function Profile({ onProfileLoad }) { // Receive onProfileLoad as a prop
    const toast = useRef(null);
    const [birthDay, setBirthDay] = useState(null);
    const [visible, setVisible] = useState(false);
    const [loader, setLoader] = useState(false);
    const [validated, setValidated] = useState(false);
    const [address, setAddress] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobile, setMobile] = useState('');
    const [number, setNumber] = useState('');
    const [groupTp, setGroupTp] = useState('');
    const [gender, setGender] = useState({
        code: 3,
        name: 'نامشخص'
    });
    const [married, setMarried] = useState({
        code: 0,
        name: 'اعلام نشده'
    });
    const [email, setEmail] = useState('');
    const [group, setGroup] = useState('');
    const [childs, setChilds] = useState('');
    const [lat, setLat] = useState(35.6892);
    const [lng, setLng] = useState(51.3890);
    const [familiar, setFamiliar] = useState({
        code: '',
        name: ''
    });
    const [customerData, setCustomerData] = useState();
    const { setCustomerInfo } = useContext(CustomerContext);  // Get setCustomerInfo from context

    const getCustomer = async (mobile) => {
        try {
            let response = await GetCustomerInfo(mobile);
            if (response.data != null || response.status === 200) {
                setCustomerInfo(response.data);
                setChilds(response.data.childs)
                setGroup(response.data.customergroupid)
                setGroupTp(response.data.customergrouptp)
                setEmail(response.data.email)
                setNumber(response.data.customernumber)
                setMobile(response.data.mobile)
                setLastName(response.data.lname)
                setFirstName(response.data.fname)
                setAddress(response.data.addres)
                setLat(response.data.lat === '0' ? '35.6892' : response.data.lat)
                setLng(response.data.lng === '0' ? '51.3890' : response.data.lng)
                setGender({
                    code: response.data.gender,
                    name: response.data.gender === '2' ? 'زن' : (response.data.gender === '3' ? 'نامشخص' : 'مرد')
                })
                setMarried({
                    code: response.data.married,
                    name: response.data.married === '1' ? 'مجرد' : (response.data.married === '0' ? 'اعلام نشده' : 'متاهل')
                })
                setFamiliar({
                    code: response.data.familiar,
                    name: response.data.familiartp
                })
                setBirthDay(response.data.birthday)
            }
        } catch (error) {
            console.error(error);
        } finally {
            onProfileLoad(); // Notify Home component that profile data is loaded
        }
    }
    const showSuccess = (success) => {
        toast.current.show({ severity: 'success', detail: success.text, life: 10000 });
    }
    const showError = (error) => {
        toast.current.show({ severity: 'error', detail: error.text, life: 10000 });
    }
    useEffect(() => {
        let customerDatares = window.localStorage.getItem('userInfo');
        setCustomerData(JSON.parse(customerDatares));
        getCustomer(JSON.parse(customerDatares).mobile);
    }, []);

    const items = [{ label: 'پروفایل من' }];
    const home = { label: 'باشگاه مشتریان', url: '/' };

    const handleAddressSelect = (selectedAddress, lat, lng) => {
        setLng(lng)
        setLat(lat)
        setAddress(selectedAddress);
    };
    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };
    // const convertDateToEn = (date) => {
    //     if (!date) return '-';
    //     console.log(moment(date, 'jYYYY/jMM/jDD').format('YYYY/MM/DD'))
    //     return moment(date, 'jYYYY/jMM/jDD').format('YYYY/MM/DD');
    // };
    const submit = async (e) => {
        e.preventDefault();
              console.log('birthDay:', birthDay, typeof birthDay)
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            if (!birthDay || birthDay.trim() === "") {
                showError({ text: 'لطفا تاریخ تولد را وارد کنید.' });
                return;
            }
            let payload = {
                Id: (customerData.customerid).toString(),
                married: married.code,
                address: address,
                childs: childs?.toString(),
                email: email,
                mobile: mobile,
                group: group,
                groupTp: groupTp,
                number: number?.toString(),
                gender: gender.code,
                lName: lastName,
                fName: firstName,
                birthDay: birthDay ? birthDay : '',
                familiar: familiar.code,
                lng: lng?.toString(),
                lat: lat?.toString()
            };
            try {
                setLoader(true);
                let res = await UpdateCustomer(payload);
                console.log(res)
                
                if (res.data[0]?.Res === 'Ok') {
                    setLoader(false);
                    setCustomerInfo(  {
                        Id: (customerData.customerid).toString(),
                        married: married.code,
                        address: address,
                        childs: childs.toString(),
                        email: email,
                        mobile: mobile,
                        group: group,
                        groupTp: groupTp,
                        number: number.toString(),
                        gender: gender.code,
                        lname: lastName,
                        fname: firstName,
                        birthDay: birthDay ? birthDay : '',
                        familiar: familiar.code,
                        lng: lng.toString(),
                        lat: lat.toString()
                    });

                    let pay = {
                        text: res.data[0]?.ResTp
                    }
                    showSuccess(pay)
                } else {
                    let pay = {
                        text: res.data[0]?.ResTp
                    }
                    showError(pay)
                    setLoader(false);
                }
            } catch (error) {
                setLoader(false);
            }
        }
        setValidated(true);
    }
    const familiarOption = [
        { name: 'سایر', code: '0' },
        { name: 'از طریق مراجعه حضوری به یکی از شعب طبیعی باش', code: '1' },
        { name: 'از طریق اسنپ فود', code: '2' },
        { name: 'از طریق فضای مجازی', code: '3' },
        { name: 'معرفی شده توسط دوستان و آشنایان', code: '4' }
    ];
    const genderOption = [
        { name: 'نامشخص', code: '3' },
        { name: 'زن', code: '2' },
        { name: 'مرد', code: '1' }];
    const marriedOption = [
        { name: 'اعلام نشده', code: '0' },
        { name: 'مجرد', code: '1' },
        { name: 'متاهل', code: '2' }];
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
    return (
        <div>
            <Toast ref={toast} />
            <BreadCrumb model={items} home={home} className='bread-crumb' />
            <h6 className='page-title my-4'>پروفایل من</h6>
            <Form className='row mx-2 gx-5 mb-4' noValidate validated={validated} onSubmit={(e) => submit(e)}>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>نام <span className='text-[red]' style={{ color: 'red' }}> * </span></Form.Label>
                    <Form.Control required type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                    <Form.Control.Feedback type="invalid">
                        نام را وارد کنید.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>نام خانوادگی <span className='text-[red]' style={{ color: 'red' }}> * </span></Form.Label>
                    <Form.Control required type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                    <Form.Control.Feedback type="invalid">
                        نام خانوادگی را وارد کنید.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>شماره اشتراک <span className='text-[red]' style={{ color: 'red' }}> * </span></Form.Label>
                    <Form.Control required type="number" disabled value={number} onChange={(e) => setNumber(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>شماره همراه <span className='text-[red]' style={{ color: 'red' }}> * </span></Form.Label>
                    <Form.Control required type="number" disabled value={mobile} onChange={(e) => setMobile(e.target.value)} />
                    <Form.Control.Feedback type="invalid">
                        شماره همراه را وارد کنید.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>جنسیت</Form.Label>
                    <Dropdown  value={gender} onChange={(e) => setGender(e.value)} options={genderOption} optionLabel="name"
                        className="w-100 " />

                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>تاهل </Form.Label>
                    <Dropdown  value={married} onChange={(e) => setMarried(e.value)} options={marriedOption} optionLabel="name"
                        className="w-100 " />

                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>آدرس </Form.Label>
                    <div className='d-flex align-items-center gap-2'>
                        
                        <Form.Control  type="text" value={address} onChange={(e) => {if(e.target.value == ''){setAddress(e.target.value)
                        setLat('')
                        setLng('')}
                        else {setAddress(e.target.value)}}} />
                   
                        <button type='button' className='btn' style={{ backgroundColor: '#669D24' }} onClick={() => setVisible(true)}>
                            <img src={MapIcon} alt="Map Icon" />
                        </button>
                    </div>
                    {/* <Form.Control.Feedback type="invalid">
                            آدرس را وارد کنید.
                        </Form.Control.Feedback> */}
                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>ایمیل</Form.Label>
                    <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>گروه <span className='text-[red]' style={{ color: 'red' }}> * </span></Form.Label>
                    <Form.Control required type="text" disabled value={groupTp} onChange={(e) => setGroupTp(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>تاریخ تولد <span className='text-[red]' style={{ color: 'red' }}> * </span></Form.Label>
                    <DatePicker
                        
                        weekDays={weekDays}
                        value={birthDay}
                        onChange={(date) => setBirthDay(convertDateToPersian(date.toDate()))}
                        calendar={persian}
                        locale={persian_fa}
                    />
                </Form.Group>
                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>تعداد فرزند</Form.Label>
                    <Form.Control type="number" value={childs} onChange={(e) => setChilds(e.target.value)} />
                </Form.Group>

                <Form.Group className="mb-3 col-md-4 col-lg-4 col-sm-12">
                    <Form.Label>نحوه آشنایی</Form.Label>
                    <Dropdown  value={familiar} onChange={(e) => setFamiliar(e.value)} options={familiarOption} optionLabel="name"
                        className="w-100 " />
                </Form.Group>
                <div className='text-start d-flex justify-content-end w-100'>
                    <button type='submit' disabled={loader} className='btn btn-primary d-flex align-items-center justify-content-center gap-2' style={{ width: 'auto' }} >
                        {loader && <Loadr />}ذخیره اطلاعات
                    </button>
                </div>
            </Form>

            <Dialog header="موقعیت مکانی" visible={visible} maximizable onHide={() => setVisible(false)}>
                <Divider />
                <h6 className='my-2 mb-4'>لطفا موقعیت مکانی خود را مشخص کنید.</h6>
                <MapComponent
                    lat={lat}
                    lng={lng}
                    onSelect={handleAddressSelect}
                />
                <button type='button' className='btn w-100 btn-primary my-4 ' onClick={() => setVisible(false)}>
                    ثبت
                </button>
            </Dialog>
        </div>
    );
}

export default Profile;
